/* eslint-disable */
import {userIint,getInfo,sendMsg,getCode,getTicketTypeInfoList, getTicketDeployTemplateList} from "../services/app";
import Loading from "../components/Loading";

function change(arr){
    arr.forEach(o => {
        if(o.nodeFlag){
            change(o.items);
        }
        o.title = o.typeName;
        o.value = o.typeId;
        if(o.items){
            o.disabled = true;
            o.children = o.items;
        }
    });
}
// function randomWord () {
//     let str = "",
//         arr = ['0','1','2','3','4','5','6','7','8','9','a','b','c','d','e','f'];
//     let id;
//     for(let i = 0 ; i < 32 ; i++){
//         id = parseInt(Math.random()* (arr.length - 1));
//         str += arr[id];
//     }
//     return str;
// }
export default {
    namespace: 'app',
    state: {
        sbumitFlag:false,
        ids:{},
        item:{},
        fieldConfig:[],
        ticketTypeList:[],
        // templateList: [],
        showType: '',
        deployConfigInfo: {
            item:{
                msgTitle:"",
                listTitle:"",
                detailTitle:""
            }
        },
        isTemplate: true,
        cusParamsField:[]
    },
    reducers: {
        update(state, {payload}) {
            return {
                ...state,
                ...payload,
            }
        },
        idsInfo(state,{ payload }){
            return {...state, ids: payload};
        },
        configInfo(state,{ payload }){
            return {...state ,deployConfigInfo: payload};
        },
        templateInfo(state,{ payload }){
            return {...state, item: payload};
        },
        fieldInfo(state,{ payload }){
            return {...state, fieldConfig: payload};
        },
        confirmInfo(state,{ payload }){
            return {...state, sbumitFlag: payload};
        },
        changeItem(state, { payload }){
            return {...state, showType: payload}
        }

    },
    effects: {
        *getTemplate({ payload }, { call, put }){
            Loading.open();
            const info = yield call(userIint,{
                sysNum : payload.sysNum,
                partnerId : window.urlObject.partnerId || '',
                agid : !window.urlObject.partnerId ? (window.urlObject.uid || '') : '',
                ticketFlag: 1
            });
            const uid = info.uid;
            window.urlObject.uid = uid;
            yield put({
                type : 'idsInfo',
                payload : {
                    uid : uid,
                    companyId : info.pid,
                }
            });

            const deployConfigInfo = yield call(getTicketDeployTemplateList, {
                deployId: payload.deployId
            });
            document.title = deployConfigInfo.item.deployName
            // changeTitle(deployConfigInfo.item.deployName)
            yield put({
                type: 'configInfo',
                payload: deployConfigInfo
            });
            if(window.urlObject.params){
                yield put({
                    type: 'getCusParams',
                    payload: {
                        uid: window.urlObject.uid,
                    }
                });
            }
            if ((deployConfigInfo.items || []).length === 1){
                yield put({
                    type: 'changeItem',
                    payload: deployConfigInfo.item.deployName === '历史工单' ? 3 : 1
                });
                yield put({
                    type: 'getList',
                    payload: {
                        uid: window.urlObject.uid,
                        companyId: window.urlObject.sysNum,
                        templateId: deployConfigInfo.items[0].templateId,
                        showType: deployConfigInfo.item.deployName === '历史工单' ? 3 : 1
                    }
                });
                yield put({
                    type: 'update',
                    payload:{
                        isTemplate: false
                    }
                });
            } else {
                yield put({
                    type: 'changeItem',
                    payload: 0
                });
                yield put({
                    type: 'update',
                    payload:{
                        isTemplate: true
                    }
                });
            }
            const lanConfig = deployConfigInfo.item.languageFlag === 2 ? 'en': 'zh';
            document.body.style.setProperty('--theme-color', deployConfigInfo.item.themeColor);

            yield put({
                type: 'locale/update',
                payload: { locale: payload.locale || lanConfig},
            });
            setTimeout(()=> {
                Loading.hide();
            },500);
        },
        *getList({payload},{call,put}){
            Loading.open();
            const uid = payload.uid;
            const templateConfig = yield call(getInfo,{
                uid:uid,
                url: 'basic-set/getCusMsgTemplateConfig/4',
                method: 'get',
                param: '{"templateId":"'+payload.templateId+'"}'
            });
            yield put({ type: 'templateInfo', payload: templateConfig.item });
            const fieldConfig = yield call(getInfo,{
                uid:uid,
                url: 'basic-set/getTemplateFieldsInfo/4',
                method: 'get',
                param: '{"operateType":3,"openFlag":1,"templateId":"'+payload.templateId+'"}'
            });
            const list = fieldConfig.items.filter(item => item.cusFieldConfig.operateType !== 31);
            yield put({ type: 'fieldInfo', payload: list });
            if(templateConfig.item.ticketTypeFlag === 1 || templateConfig.item.ticketTypeFlag === 2){
                const arr = yield call(getTicketTypeInfoList,{
                    uid:uid,
                    url: '/ws/queryTicketTypeInfoList/4',
                    method: 'get'
                });
                change(arr.items);
                yield put({ type: 'update', payload: { ticketTypeList:arr.items } });
            }
            yield put({type: 'changeItem', payload:payload.showType});
            setTimeout(()=> {
                Loading.hide();
            },500);
        },
        *getCusParams({payload},{call,put}){
            const data = yield call(getInfo,{
                uid:payload.uid,
                url: 'ws/getTicketPartnerFields/4',
                method: 'get',
            });
            let params = null;
            let cusParamsField = [];
            try {
                const str = decodeURI(window.urlObject.params)
                if (typeof JSON.parse(str) === "object") {
                    params = JSON.parse(str);
                }
            } catch (e) {
                alert("JSON格式错误!")
                params = null;
            }
            data.items.forEach(i => {
                for (let key in params) {
                    if(i.fieldParams === key){
                        cusParamsField.push({
                            id:i.fieldId,
                            value:params[key],
                            fieldName:i.fieldName,
                            params:i.fieldParams
                        })
                    }
                }
            })
            yield put({
                type:"update",
                payload:{
                    cusParamsField
                }
            })
        },
        // 获取手机号验证码
        *getCode({ payload,callback }, { call, put }){
            const data = yield call(getCode, {
                phoneNo: payload.phoneNo,
                type: payload.type,
            });
            callback(data);
        },
        *postMsg({ payload,callback }, { call, put }){
            const data = yield call(sendMsg,{
                ...payload.data,
                partnerId: window.urlObject.partnerId || '',
                sysNum: window.urlObject.sysNum || ''
            });
            if(data.retCode === '000000'){
                yield put({
                    type: 'update',
                    payload: {
                        sbumitFlag:true
                    }
                });
                callback(data);
            }else{
                alert(data.retMsg)
                callback(data);
            }
        }
    },
    subscriptions:{
        setup({ dispatch }) {
            init(window.location.search,dispatch);
            // if (window.parent.length > 0) {
            //     window.addEventListener('message',function (e) {
            //         if(e.data.type === "zhichi-ticketclient-iframe"){
            //             link = e.data.data;
            //             init(link,dispatch);
            //         }
            //     });
            // } else {
            //     link = window.location.search;
            //     init(link,dispatch);
            // }
        }
    }
}

function init(link,dispatch){
    let q = {};
    link.replace(/([^?&=]+)=([^&]+)/g, (_, k, v) => q[k] = v);
    dispatch({
        type: 'getTemplate',
        payload: q
    });
}
